import React from "react";
import searchIcon from "../../../assets/searchIcon.png";
import { TableContent } from "./data";
import "../AdminDashBoard.css";

const index = () => {
  return (
    <div className="row">
      <div className="col-md-1"></div>
      {/* <!-- Sales --> */}
      <div className="col-11 TableMax-width mx-auto my-5 py-md-5 marginTop10">
        <div className="row">
          <div className="col-md-12">
            <h2 className="TableHeading">Sales</h2>
          </div>
          <div className="col-md-12">
            {/* <!-- Tabs --> */}
            <div className="TabWrapper TabWrap_Noradius">
              <ul className="mb-3 StashTabs_Link">
                <ul
                  className="left_SLink nav nav-pills"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className="active"
                      id="pills-sale1-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-sale1"
                      type="button"
                      role="tab"
                      aria-controls="pills-sale1"
                      aria-selected="true"
                    >
                      Stashes
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className=""
                      id="pills-sale2-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-sale2"
                      type="button"
                      role="tab"
                      aria-controls="pills-sale2"
                      aria-selected="false"
                    >
                      Wavpools
                    </button>
                  </li>
                </ul>
                <ul className="Right_SLink">
                  <li className="me-0 InputWrapper">
                    <input
                      type="text"
                      placeholder="Search"
                      className="Right_SLinkInput"
                    />
                    <span className="Right_SLinkSelectWrapper">
                      <select name="" id="" className="Right_SLinkSelect">
                        <option value="">Category</option>
                        <option value="">Category</option>
                      </select>
                    </span>
                    <button className="Right_SLinkBtn">
                      <img src={searchIcon} className="img-fluid" alt="" />
                    </button>
                  </li>
                  <li>
                    <span className="d7">7d</span>
                  </li>
                  <li>
                    <span className="d7">30d</span>
                  </li>
                  <li>
                    <button className="CreateBtn">Detailed</button>
                  </li>
                </ul>
              </ul>
              <div
                className="tab-content StashTabs_Content"
                id="pills-tabContent"
              >
                {/* <!-- 1 Tabs --> */}
                <div
                  className="tab-pane fade show active"
                  id="pills-sale1"
                  role="tabpanel"
                  aria-labelledby="pills-sale1-tab"
                >
                  {/* <!-- Table Header --> */}
                  <div className="TableHeader">
                    <div className="row row-cols-7 mx-0">
                      <div className="col-3">
                        <span className="">Rank</span>
                      </div>
                      <div className="col">
                        <span>Unique Collectors</span>
                      </div>
                      <div className="col-2">
                        <span>Total NFT Sold</span>
                      </div>
                      <div className="col">
                        <span>Primary Sales</span>
                      </div>
                      <div className="col">
                        <span>Secondary Sales</span>
                      </div>
                      <div className="col">
                        <span>Total Sales</span>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Table Content --> */}
                  {TableContent.map((item) => {
                    const SaleImg = require(`../../../assets/${item.RankImg}`);
                    return (
                      <div className="TableContent">
                        <div className="row row-cols-7 mx-0">
                          <div className="col-3">
                            <span className="img-txt me-3">{item.RankNo}</span>

                            <img
                              src={SaleImg}
                              className="img-fluid me-3"
                              alt=""
                            />
                            <span className="img-txt">{item.RankName}</span>
                          </div>
                          <div className="col">
                            <span className="fw-bold">{item.Unique}</span>
                          </div>
                          <div className="col">
                            <span className="fw-bold">{item.TotalNFT}</span>
                          </div>
                          <div className="col-2">
                            <span>{item.PrimarySale}</span>
                          </div>
                          <div className="col">
                            <span>{item.SecondarySale}</span>
                          </div>
                          <div className="col">
                            <span>{item.TotalSales}</span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {/* <!-- Table Footer --> */}
                  <div className="TableFooter">
                    <div className="row mx-0 justify-content-between">
                      <div className="col-3">
                        <button className="btn Btn_Previous">Previous</button>
                      </div>
                      <div className="col-3 d-flex justify-content-center">
                        <span className="Page_txt">Page 1 of 10</span>
                      </div>
                      <div className="col-3 d-flex justify-content-end">
                        <button className="btn Btn_Previous">Next</button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!-- 2 Tabs --> */}
                <div
                  className="tab-pane fade"
                  id="pills-sale2"
                  role="tabpanel"
                  aria-labelledby="pills-sale2-tab"
                >
                  {/* <!-- Table Header --> */}
                  <div className="TableHeader">
                    <div className="row row-cols-7 mx-0">
                      <div className="col-3">
                        <span className="">Rank</span>
                      </div>
                      <div className="col">
                        <span>Unique Collectors</span>
                      </div>
                      <div className="col-2">
                        <span>Total NFT Sold</span>
                      </div>
                      <div className="col">
                        <span>Primary Sales</span>
                      </div>
                      <div className="col">
                        <span>Secondary Sales</span>
                      </div>
                      <div className="col">
                        <span>Total Sales</span>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Table Content --> */}
                  {TableContent.map((item) => {
                    const SaleImg = require(`../../../assets/${item.RankImg}`);
                    return (
                      <div className="TableContent">
                        <div className="row row-cols-7 mx-0">
                          <div className="col-3">
                            <span className="img-txt me-3">{item.RankNo}</span>

                            <img
                              src={SaleImg}
                              className="img-fluid me-3"
                              alt=""
                            />
                            <span className="img-txt">{item.RankName}</span>
                          </div>
                          <div className="col">
                            <span>{item.Unique}</span>
                          </div>
                          <div className="col">
                            <span>{item.TotalNFT}</span>
                          </div>
                          <div className="col-2">
                            <span>{item.PrimarySale}</span>
                          </div>
                          <div className="col">
                            <span>{item.SecondarySale}</span>
                          </div>
                          <div className="col">
                            <span>{item.TotalSales}</span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {/* <!-- Table Footer --> */}
                  <div className="TableFooter">
                    <div className="row mx-0 justify-content-between">
                      <div className="col-3">
                        <button className="btn Btn_Previous">Previous</button>
                      </div>
                      <div className="col-3 d-flex justify-content-center">
                        <span className="Page_txt">Page 1 of 10</span>
                      </div>
                      <div className="col-3 d-flex justify-content-end">
                        <button className="btn Btn_Previous">Next</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!--ENd Tabs --> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default index;
